<template>
	<button class="btn-default" style="min-width: fit-content" v-on="$listeners">
		<span>{{ backButtonTitle }}</span>
	</button>
</template>

<script>
export default {
	name: 'BaseBackButton',
	props: {
		backButtonTitle: {
			type: String,
			default: function() {
				return this.$t('general.back');
			},
		},
	},
};
</script>

<style lang="sass" scoped></style>
